import * as React from "react";
import { ThirdPartyIcon, ThirdPartyIconType } from "~/primitiveComponents/dataDisplay/Icon/index";
import styles from "./DropDownIcon.module.less";
export function DropDownIcon() {
    return <ThirdPartyIcon iconType={ThirdPartyIconType.ArrowDropDown} className={styles.icon}/>;
}
